module.exports = __webpack_public_path__ + "static/media/logo-fantasy.0cd0fd86.png";